import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import { PENGELOLAAN_KINERJA_KS_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { assetUrl } from 'utils/url'

import type { PelaksanaanState } from 'types/kinerja-ks-pelaksanaan'

type Props = {
  className?: string
  step: PelaksanaanState
  isGuru?: boolean
}

export function CardPelaksanaanStepResetKs({ className, step, isGuru }: Props) {
  const stepData = PENGELOLAAN_KINERJA_KS_PELAKSANAAN_STEPS[step]

  if (!stepData) return null

  return (
    <div
      className={clsx(
        'rounded border border-red-60 bg-red-5 flex space-x-2 p-3 items-center',
        className
      )}
    >
      <img
        src={assetUrl(stepData.imagePath)}
        alt=""
        width={64}
        height={64}
        className="flex-shrink-0"
      />
      <div className="space-y-1">
        <Text variant="heading-sm">{stepData.title}</Text>
        <Text variant="body-sm" color="critical">
          {(isGuru && stepData.resetMessageGuru) || stepData.resetMessage}
        </Text>
      </div>
    </div>
  )
}
